<template>
  <div>
    <v-tabs vertical :color="colorTheme">
      <v-tab :style="styleTab" id="alignTab" v-on:click="title($t('personalization'))">
        <v-icon class="icon-size" left>mdi-account</v-icon>
        <strong
          class="regularText"
          v-if="this.$store.state.visible == true"
        >{{ $t("personalization") }}</strong>
      </v-tab>
      <v-tab :style="styleTab" id="alignTab" v-on:click="title($t('changeTheme'))">
        <v-icon class="icon-size" left>mdi-palette</v-icon>
        <strong
          class="regularText"
          v-if="this.$store.state.visible == true"
        >{{ $t("changeTheme") }}</strong>
      </v-tab>
      <v-tab :style="styleTab" id="alignTab" v-on:click="title($t('SystemofUnits'))">
        <v-icon class="icon-size" left>mdi-ruler</v-icon>
        <strong
          class="regularText"
          v-if="this.$store.state.visible == true"
        >{{ $t("SystemofUnits") }}</strong>
      </v-tab>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="auto" class="regularText">{{ $t("darkMode") }}</v-col>
              <v-spacer />
              <v-col cols="auto">
                <v-switch v-model="swicth" class="ma-0 pa-0" hide-details :color="colorTheme" />
              </v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
            <v-row no-gutters>
              <v-col cols="auto" class="regularText">{{ $t("changeLogo") }}</v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn
                  :color="colorTheme"
                  icon
                  @click="
                    $refs.inputUpload.click();
                    alertImage();
                  "
                >
                  <v-icon class="icon-size">mdi-camera</v-icon>
                </v-btn>
                <input
                  v-show="false"
                  ref="inputUpload"
                  type="file"
                  @change="previewImage"
                  accept="image/*"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text class="pa-0">
            <v-container :style="styleColorPicker">
              <v-color-picker
                v-model="colorSelect"
                class="ma-1"
                :style="colorPickerWidth"
                show-swatches
              ></v-color-picker>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="regularText"
              :color="colorTheme"
              text
              v-on:click="setColorSelected()"
            >{{ $t("apply").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-container>
              <v-col cols="auto">
                <v-select
                  :label="$t('distance')"
                  dense
                  outlined
                  v-model="SelectedDistance"
                  :color="colorTheme"
                  :items="Distance"
                ></v-select>
              </v-col>
              <v-col cols="auto">
                <v-select
                  :label="$t('volume')"
                  dense
                  outlined
                  v-model="SelectedVolume"
                  :color="colorTheme"
                  :items="Volumen"
                ></v-select>
              </v-col>
              <v-col cols="auto">
                <v-select
                  :label="$t('temperature')"
                  dense
                  outlined
                  v-model="SelectedTemperature"
                  :color="colorTheme"
                  :items="Temperature"
                ></v-select>
              </v-col>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="regularText"
              :color="colorTheme"
              text
              v-on:click="convertData()"
            >{{ $t("apply").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import Highcharts from "highcharts";
import darkUnica from "highcharts/themes/dark-unica";
import { mapState } from "vuex";

export default {
  name: "personalization",
  data: () => ({
    color: "#E91E63",
    visible: false,
    visibleUnit: false,
    colorSelect: "",
    menu: false
  }),
  computed: {
    ...mapState([
      "colorTheme",
      "distance",
      "volume",
      "temperature",
      "Distance",
      "Volumen",
      "Temperature",
      "styleTab",
      "styleColorPicker",
      "colorPickerWidth"
    ]),
    swicth: {
      get: function() {
        return this.$store.state.swicth;
      },
      set: function(value) {
        this.$store.commit("swicth");
      }
    },
    SelectedDistance: {
      get: function() {
        return this.$store.state.SelectedDistance;
      },
      set: function(val) {
        this.$store.commit("SelectedDistance", val);
      }
    },
    SelectedVolume: {
      get: function() {
        return this.$store.state.SelectedVolume;
      },
      set: function(val) {
        this.$store.commit("SelectedVolume", val);
      }
    },
    SelectedTemperature: {
      get: function() {
        return this.$store.state.SelectedTemperature;
      },
      set: function(val) {
        this.$store.commit("SelectedTemperature", val);
      }
    }
  },
  watch: {
    swicth(val) {
      localStorage.setItem("darkMode", val);
      this.$vuetify.theme.dark = val;
      var color = val == true ? "" : "#f5f5f5";
      this.$store.commit("setColor", color);
      this.$store.commit("progressColor", val);
      this.$store.commit("backgroundSkeleton");
      this.$store.commit("backgroundCard");
      if (this.$store.state.viewSkeletons == false) {
        this.modifyCharts();
      }
      if (this.$route.path == "/traffic") {
        this.modifyCharts();
      }
      this.$store.dispatch("setPersonalization", ["Dark", val]);
    }
  },
  created() {
    this.colorSelect = this.$store.state.colorTheme;
    this.$store.commit("ViewUnitSystem");
    this.$store.commit("setSettingsTitle", this.$i18n.t("personalization"));
  },
  methods: {
    title: function(val) {
      this.$store.commit("setSettingsTitle", val);
    },
    convertData() {
      this.$store.commit("converData");

      this.$store.dispatch("setPersonalization", ["SU"]);
      this.modifyCharts();
    },
    async modifyCharts() {
      var ItemsDashboard = JSON.parse(localStorage.getItem("ItemsDashboard"));
      var itemTraffic = JSON.parse(localStorage.getItem("TrafficList"));
      //  var ItemsPerformance = JSON.parse(
      //   localStorage.getItem("ItemsPerformance")
      // );
      var ItemsPerformance = this.$store.state.itemsPerformanceInfo;
      if (ItemsPerformance == null) {
        ItemsPerformance = await this.$store.dispatch(
          "getItemPouchdb",
          "ItemsPerformance"
        );
      }

      if (this.$route.path == "/dashboard") {
        if (ItemsDashboard != null || ItemsDashboard != undefined) {
          this.$store.dispatch("customCharts", ItemsDashboard);
        }
      } else if (this.$route.path == "/traffic") {
        if (itemTraffic != null || itemTraffic != undefined) {
          this.$store.dispatch("customCharts", [itemTraffic, "TrafficList"]);
        }
      } else if (this.$route.path == "/dashboard/performance/individual") {
        this.$store.commit("viewSkeletonsP", true);
        this.$store.dispatch("destroyPerformanceCharts");
        this.$store.commit("setChartsValue");
        this.$store.dispatch("divideData", {
          itemsPerformance1: ItemsPerformance,
          comparative: false,
          byTrip: false
        });
      } else if (this.$route.path == "/dashboard/performance") {
        this.$store.dispatch("destroyDetailsAndTable");
        this.$store.commit("setChartsValue");
        this.$store.dispatch("createDetailsChart");
        this.$store.commit("changeHeadersMetrics");
        var val = JSON.parse(localStorage.getItem("performanceFleet"));
        this.$store.commit("fillPerformanceFleet", val);
      } else if (
        this.$route.path == "/dashboard/performance/individual/comparative"
      ) {
        this.$store.commit("setChartsValue");
        this.$store.commit("changeHeadersCompare");
        this.$store.dispatch("divideData", {
          itemsPerformance1: ItemsPerformance,
          comparative: true,
          byTrip: false
        });
      } else if (this.$route.path == "/individualFuel") {
        setTimeout(() => {
          this.$store.dispatch("convertRetrieveLevel");
          this.$store.dispatch("convertPerformanceAF");
        }, 1000);
      } else if (this.$route.path == "/tracking") {
        if (this.$store.state.statusViewVisible) {
          this.$store.commit("setItemsTracking", this.$store.state.fleetLastPositionSave);
        } else if (this.$store.state.reportViewVisible) {
          this.$store.commit("cleanClustersAndMarkersPolyline");
          this.$store.commit(
            "forActivity",
            JSON.parse(this.$store.state.dataActivitySave)
          );
        }
      }
    },
    UnitSystemVisible() {
      this.$store.commit("UnitSystemValues");
      this.visibleUnit = !this.visibleUnit;
      this.visible = false;
    },
    previewImage: function(event) {
      var input = event.target;
      if (input.files[0].size < 5242880) {
        var type = input.files[0].type.replace("image/", "");
        localStorage.setItem("typeImageLogo", type);
        if (input.files && input.files[0]) {
          var reader = new FileReader();
          reader.onload = e => {
            // this.$store.commit("imageLogo", e.target.result);
            this.$store.dispatch("setPersonalization", [
              "imageLogo",
              e.target.result
            ]);
          };
          reader.readAsDataURL(input.files[0]);
        }
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("alertImage")
        });
      }
    },
    alertImage() {
      this.$store.commit("snackbar", {
        snackbar: true,
        text: i18n.t("sizeImage"),
        x: "right"
      });
    },
    colorPickerVisible() {
      this.visible = !this.visible;
      this.visibleUnit = false;
    },
    setColorSelected() {
      localStorage.setItem("colorSelected", this.colorSelect);
      this.$store.commit("setColorSelected", this.colorSelect);
      this.$vuetify.theme.themes.light.primary = this.colorSelect;
      this.$vuetify.theme.themes.dark.primary = this.colorSelect;
      this.$store.dispatch("setPersonalization", [
        "ColorSelect",
        this.colorSelect
      ]);
      this.modifyCharts();
    }
  }
};
</script>

<style scoped>
#alignTab {
  justify-content: left;
}
</style>
